<template>
  <div class="group-list">
    <h1 class="common__main-title">Group List</h1>
    <Search
      class="search"
      @changeConditions="changeConditions"
      ref="search"
    />
    <div class="button-container">
      <b-button pill variant="primary" class="mr-3" @click="sendAnnounce">
        Send announce
      </b-button>
      <b-button pill variant="primary" class="mr-3" :to="{ name:'GroupCreate' }">
        Create Group
      </b-button>
    </div>

    <PagerComponent v-model="pager" @changePage="changePage" />
    <GroupTable :groups="groups" :total="pager.totalLength"/>
    <PagerComponent v-model="pager" @changePage="changePage" />

    <ErrorModal ref="errorModal" />
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import Vue from 'vue'
import PagerComponent from '@/components/parts/Pager.vue'
import GroupTable from '@/components/parts/group/GroupTable.vue'
import Search from '@/components/parts/group/SearchGroup.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import ErrorModal from '@/components/parts/modal/Error.vue'
import { RootState } from '@/store/types'
import { Group, GroupConditions } from '@/store/groups/types'
import { Pager } from '@/store/pager.types'

export default Vue.extend({
  components: {
    Search,
    PagerComponent,
    GroupTable,
    ErrorModal,
    Loading,
  },

  data(): {
    isLoading: boolean
    conditions: GroupConditions|null
    displayedConditions: GroupConditions|null
    } {
    return {
      isLoading: false,
      conditions: null,
      displayedConditions: null,
    }
  },

  computed: {
    groups(): Group[] {
      return (this.$store.state as RootState).groups.groups
    },
    pager(): Pager {
      return (this.$store.state as RootState).groups.pager
    },
  },

  async created() {
    const page = 1
    await this.search(this.conditions, page)
  },

  methods: {
    /**
     * グループ検索
     * @param {GroupConditions|null} conditions グループ検索条件
     * @param {number} page ページ番号
     */
    async search(conditions: GroupConditions|null, page: number) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      this.displayedConditions = _.cloneDeep(conditions);

      try {
        await this.$store.dispatch('fetchGroups', { conditions, page })
        this.isLoading = false
      } catch (error: any) {
        this.isLoading = false
        const errorMessage = error.response ? error.response.data.message : error.message;
        (this.$refs.errorModal as ErrorModal).open(errorMessage)
      }
    },

    /**
     * 条件変更
     * @param {GroupConditions} conditions 検索条件
     */
    changeConditions(conditions: GroupConditions) {
      this.conditions = conditions
      this.search(this.conditions, 1)
    },

    /**
     * ページ変更
     * @param {number} page ページ番号
     */
    changePage(page: number) {
      this.search(this.conditions, page)
    },

    /**
     * 検索条件下のグループ全体にグループ詳細の通知を行う
     */
    async sendAnnounce() {
      if (this.isLoading) {
        return
      }

      const { totalLength, last } = (this.$store.state as RootState).groups.pager
      const limit = 5000
      if (totalLength > limit) {
        this.$bvModal.msgBoxOk(`Please resetting condition at reduced under ${limit} groups`)
        return
      }

      const isOk = await this.$bvModal.msgBoxConfirm('Send emalt to all groups. Is it OK ?')
      if (isOk !== true) {
        return
      }

      this.isLoading = true

      try {
        await this.$store.dispatch('announceGroupInfoToTutorAndStudents', this.displayedConditions)
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')
      } catch (error: any) {
        const message = _.has(error, 'response') ? error.response.data.message : error.message
        this.isLoading = false
        this.$bvModal.msgBoxOk(`Failed: ${message}`)
      }
    },
  },
})
</script>

<style scoped>
.button-container {
  margin-bottom:20px;
  display: flex;
  justify-content: flex-end;
}

</style>
